import { Controller } from '@hotwired/stimulus'
import Cookies from 'js-cookie'
import { delegate } from 'tippy.js'
import { getURLParam } from '../utilities'

export default class extends Controller {
  connect() {
    this.#setupTippy()
    this.#storeTrackingParams()
    this.#handleRedirects()
  }

  #handleRedirects() {
    if (getURLParam('ls') === 'fitsmallbusiness') {
      window.location.href = 'https://partner.bookkeeper360.com/fit-small-business'
    }
  }

  #setupTippy() {
    delegate('body', {
      target: '[data-tippy-content]',
      animation: 'shift-toward',
      duration: 250,
      theme: 'light',
      placement: 'top'
    })
  }

  #storeTrackingParams() {
    const domain = '.bookkeeper360.com'

    const leadSource = getURLParam('ls')
    if (leadSource) Cookies.set('lead_source', leadSource, { domain })

    const trialLength = getURLParam('tl')
    if (trialLength) Cookies.set('trial_length', trialLength, { domain })

    const coupon = getURLParam('coupon')
    if (coupon) Cookies.set('coupon', coupon, { domain })
  }
}
